import { connect } from '../../../react-redux';
import { IfFeature as IfFeaturePresenter } from './presenter';
import { featureOn } from '../../../util/featureCheck';
export function mapStateToProps(state, props) {
  return {
    isOn: featureOn(props.name)
  };
}
export var IfFeature = connect(mapStateToProps)(IfFeaturePresenter);
export default IfFeature;